import Vue from 'vue';

export default {
  async getWinnings() {
    return (await Vue.http.get("/api/stats/winnings")).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/stats.service.js